exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tblClass[data-v-d45cd096]{border-collapse:collapse}.tblClass tr td[data-v-d45cd096],.tblClass tr th[data-v-d45cd096]{border:1px solid #ccc;padding:8px 0}.textCenter[data-v-d45cd096],.textCenter tr td[data-v-d45cd096],.textCenter tr th[data-v-d45cd096]{text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d45cd096","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/procurement/package_archive/details/dataTable.vue
// module id = 1444
// module chunks = 3